require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-161-import-from-microsoft-project.json") })
        }
      }, "path---article-161-import-from-microsoft-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-161-import-from-microsoft-project!./.cache/json/article-161-import-from-microsoft-project.json
// module id = 509
// module chunks = 231608221292675